var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueAceEditor',{ref:"editor",attrs:{"content":_vm.content,"options":_vm.editorOptions,"fontSize":14,"lang":_vm.lang,"theme":"solarized_dark"},on:{"onInput":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }